<template>
	<div class="box-two proerty-item">
    <div class="item-thumb search-exhibition-thumb">
      <a :href="exhibition.slug + '/configurate'">
        <span class="helper"></span>
        <img :src="'images/exhibitions/' + image">
      </a>
    </div>
    <div class="item-entry overflow">
      <h5>
        <a :href="exhibition.slug + '/configurate'">
          {{ name }}
        </a>
      </h5>
      <div class="dot-hr"></div>
      <ul class="list-unstyled" style="text-decoration: none">
        <li>
          <span class="proerty-place"><i class="fa fa-map-marker" aria-hidden="true"></i> <b>{{ place }}</b></span>
        </li>
        <li>
          <i class="fa fa-calendar" aria-hidden="true"></i> {{ $filters.formatDate(exhibition.from) }} - {{ $filters.formatDate(exhibition.till) }}
        </li>
      </ul>
      <p style="display: none;">{{ exhibition.description }}</p>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useMainStore } from '@/store'

const store = useMainStore()
// define passed props
const props = defineProps({
  exhibition: {
    type: Object,
    required: true,
  },
})
// define computed props
const locale = computed(() => store.settings.locale)

const image = computed(() => {
  if (props.exhibition.image !== null && props.exhibition.image != "") {
    return props.exhibition.image
  }

  return "default_search_logo.png"
})

const name = computed(() => {
  return (inEnglish.value) ? props.exhibition.name_en : props.exhibition.name
})

const place = computed(() => {
  return (inEnglish.value) ? props.exhibition.place_en : props.exhibition.place
})

const inEnglish = computed(() => {
  return locale.value === "en"
})
</script>